import { useSelector, useDispatch } from 'react-redux';
import { login, logout, fetchMe } from '@/redux/slices/authSlice';

// Thin accessor for the auth slice + actions.
export default function useAuth() {
  const dispatch = useDispatch();
  const { admin, token, isAuthenticated, loading, error } = useSelector((s) => s.auth);

  return {
    admin,
    token,
    isAuthenticated,
    loading,
    error,
    login: (credentials) => dispatch(login(credentials)).unwrap(),
    logout: () => dispatch(logout()),
    refreshMe: () => dispatch(fetchMe()),
  };
}
